import React, { useMemo, useRef } from "react";
import { observer } from "mobx-react-lite";

import {
  SegmentationStatus,
  VideoAnalysisService,
} from "../../../services/inspection/VideoAnalysisService";
import Button from "../../button/Button";
import { translationService } from "../../../services/translation/TranslationService";
import "./HighlightDetectedDamagesFilter.scss";

interface HighlightDetectedDamagesFilterProps {
  videoAnalysis?: VideoAnalysisService;
}

export const HighlightDetectedDamagesFilter = observer(
  (props: HighlightDetectedDamagesFilterProps) => {
    const { videoAnalysis } = props;

    const buttonRef = useRef(null);
    const containerRef = useRef(null);

    const filtersButtonText = useMemo(() => {
      const segmentationStatus = videoAnalysis?.segmentationStatus;

      if (segmentationStatus === SegmentationStatus.InProgress) {
        return "damages.highlight-detection.filter-on-video.running-hd";
      }

      if (segmentationStatus === SegmentationStatus.Failed) {
        return "damages.highlight-detection.filter-on-video.failed-hd";
      }

      return "";
    }, [videoAnalysis?.segmentationStatus]);

    return (
      <div ref={containerRef}>
        <Button
          id="filter-damages-button"
          ref={buttonRef}
          className={`filters-button ${SegmentationStatus[
            videoAnalysis?.segmentationStatus!
          ].toLowerCase()}`}
          disabled={
            videoAnalysis?.segmentationStatus === SegmentationStatus.Failed ||
            videoAnalysis?.segmentationStatus === SegmentationStatus.InProgress
          }
        >
          <div>{translationService.translate(filtersButtonText)}</div>
        </Button>
      </div>
    );
  }
);
